import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { CompetingTimeSlotsLayoutComponent } from './layouts/competing-time-slots-layout/competing-time-slots-layout.component';
import { CompetingTimeSlotsDatatableComponent } from './components/competing-time-slots-datatable/competing-time-slots-datatable.component';

const DECLARATIONS = [
  CompetingTimeSlotsLayoutComponent,
  CompetingTimeSlotsDatatableComponent
];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class CompetingTimeSlotsModule {}
